var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientPhoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4267 12.7677L15.1997 11.5416C14.8747 11.2168 14.4341 11.0344 13.9747 11.0344C13.5153 11.0344 13.0747 11.2168 12.7497 11.5416L12.1367 12.1547C11.976 12.3159 11.7851 12.4437 11.5749 12.531C11.3647 12.6182 11.1393 12.6631 10.9117 12.6631C10.6842 12.6631 10.4588 12.6182 10.2486 12.531C10.0384 12.4437 9.84747 12.3159 9.68676 12.1547L7.84878 10.3145C7.52391 9.98915 7.34144 9.54816 7.34144 9.08837C7.34144 8.62858 7.52391 8.18758 7.84878 7.86224L8.46077 7.24918C8.78564 6.92384 8.96811 6.48284 8.96811 6.02305C8.96811 5.56326 8.78564 5.12227 8.46077 4.79693L7.23679 3.5708C7.08661 3.39204 6.89913 3.24831 6.68751 3.1497C6.47589 3.0511 6.24526 3 6.0118 3C5.77834 3 5.54771 3.0511 5.33609 3.1497C5.12447 3.24831 4.93699 3.39204 4.78681 3.5708C1.56385 6.77113 3.08483 10.4675 6.3058 13.6888C9.52676 16.9102 13.2197 18.4343 16.4257 15.224C16.6055 15.0738 16.7501 14.886 16.8493 14.6738C16.9486 14.4616 17 14.2301 17 13.9959C17 13.7616 16.9486 13.5302 16.8493 13.318C16.7501 13.1058 16.6065 12.9179 16.4267 12.7677Z",
    stroke: "#172A47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientPhoneOutline);
export default __webpack_public_path__ + "static/media/Patient_phone-outline.2f21b964e52a0911fb8ce10ff506b0b8.svg";
export { ForwardRef as ReactComponent };